var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsOtherInvestments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1574.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Other-investments",
    transform: "translate(5026.000000, 1574.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,17 C25.464,17 24.967,16.848 24.532,16.601 L19.851,20.111 C19.939,20.394 20,20.688 20,21 C20,22.657 18.657,24 17,24 C16.007,24 15.133,23.512 14.587,22.768 L9.985,24.148 C9.906,25.735 8.606,27 7,27 C5.343,27 4,25.657 4,24 C4,22.343 5.343,21 7,21 C7.993,21 8.867,21.488 9.413,22.232 L14.015,20.851 C14.094,19.265 15.395,18 17,18 C17.615,18 18.186,18.187 18.662,18.503 L23.212,15.091 C23.08,14.752 23,14.386 23,14 C23,12.343 24.343,11 26,11 C27.657,11 29,12.343 29,14 C29,15.657 27.657,17 26,17 M28,7 L14,7 L10,1 L0,1 L0,27 C0,29.209 1.791,31 4,31 L32,31 L32,11 C32,8.791 30.209,7 28,7",
    id: 16
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsOtherInvestments);
export default __webpack_public_path__ + "static/media/investments-other-investments.6be94311.svg";
export { ForwardRef as ReactComponent };